import {
  doiDefinition,
  issnDefinition,
  contributorDefinition,
  publicationDatesDefinition,
} from '../common/common-schemas';

const commonDefinitions = {
  contributor: contributorDefinition,
  issn: issnDefinition,
  publicationDates: publicationDatesDefinition,
};

export const updateNoticeSchema = {
  $schema: 'http://json-schema.org/draft-07/schema',
  title: 'Update Notice',
  type: 'object',
  required: [
    'updateType',
    'title',
    'doi',
    'resourceUrl',
    'updatedArticleDoi',
    'publicationDates',
  ],
  properties: {
    updateType: {
      type: 'string',
      enum: [
        'addendum',
        'clarification',
        'correction',
        'corrigendum',
        'erratum',
        'expression_of_concern',
        'new_edition',
        'new_version',
        'partial_retraction',
        'removal',
        'retraction',
        'withdrawal',
      ],
      i18n: 'postPublicationUpdate_updateType',
    },
    title: {
      type: 'string',
      i18n: 'postPublicationUpdate_title',
    },
    doi: {
      ...doiDefinition,
      title: 'DOI of update notice',
      i18n: 'postPublicationUpdate_doi',
    },
    resourceUrl: {
      type: 'string',
      format: 'url',
      notDoiUrl: true,
      i18n: 'postPublicationUpdate_resourceUrl',
    },
    updatedArticleDoi: {
      ...doiDefinition,
      title: 'DOI of article being updated',
      i18n: 'postPublicationUpdate_updatedArticleDoi',
    },
    contributors: {
      type: 'array',
      items: {
        $ref: '#/definitions/contributor',
      },
      i18n: 'postPublicationUpdate_contributors',
    },
    publicationDates: {
      $ref: '#/definitions/publicationDates',
    },
  },
  definitions: {
    ...commonDefinitions,
  },
};

export const journalSchema = {
  $schema: 'http://json-schema.org/draft-07/schema',
  title: 'Journal',
  type: 'object',
  required: ['issn', 'titles', 'crossmarkPolicyPage'],
  properties: {
    issn: {
      type: 'object',
      requireAny: ['onlineIssn', 'printIssn'],
      i18n: 'postPublicationUpdate_journal_issn',
      properties: {
        onlineIssn: {
          $ref: '#/definitions/issn',
        },
        printIssn: {
          $ref: '#/definitions/issn',
        },
      },
    },
    titles: {
      type: 'object',
      required: ['fullTitle'],
      properties: {
        fullTitle: {
          type: 'string',
          i18n: 'postPublicationUpdate_journal_fullTitle',
        },
        abbreviatedTitle: {
          type: 'string',
          i18n: 'postPublicationUpdate_journal_abbreviatedTitle',
        },
      },
    },
    crossmarkPolicyPage: {
      ...doiDefinition,
      i18n: 'postPublicationUpdate_journal_crossmarkPolicyPage',
    },
  },
  definitions: {
    ...commonDefinitions,
    issn: issnDefinition,
  },
};

export const postPublicationUpdateRecordSchema = {
  $schema: 'http://json-schema.org/draft-07/schema',
  title: 'Post-Publication Update',
  type: 'object',
  required: ['updateNotice', 'journal'],
  properties: {
    updateNotice: updateNoticeSchema,
    journal: journalSchema,
  },
  definitions: {
    ...commonDefinitions,
  },
};
